<template>
  <div class="network-account-config-component">
    <a @click="openModal"><i class="fa fa-edit"></i></a>

    <div class="modal fade" v-bind:id="'network-options-' + accountId">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" @click="statusClass = ''">×</button>
            <h5 class="modal-title">Options</h5>
            <h5 class="modal-title"><small>{{accountName}}</small></h5>
          </div>
          <div class="modal-body">
            <table class="table table-responsive">
              <thead>
              <tr>
                <th>Option</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-bind:class="statusClass">
                <td>Show Consumer Duty</td>
                <td class="text-center">
                  <input type="checkbox" v-model="featuresConsumerDuty" @change="changeViewQuestionSection('consumer_duty')">
                </td>
              </tr>
              <tr v-if="additional_options_member_firm_data_download">
                <td class="row" style="display: flex; align-items: center; justify-content: space-between;">
                  <div class="col-md-8">Member firm data download</div>
                  <select
                      name="export_account_option"
                      id="export_account_option"
                      class="form-control col-md-4"
                      v-model="exportAccountOption">
                    <option v-for="(value,label) in exportAccountOptions" :value="value" :key="label">{{ label }}</option>
                  </select>
                </td>
                <td class="text-center">
                  <i v-if="exportAccountProcess" class="fa fa-spinner fa-spin" style="padding: 8px 40px;"></i>
                  <button v-else type="button" class="btn btn-link" @click="exportAccount" style="margin: -8px auto">
                    <i class="fa fa-download"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NetworkAccountConfigComponent",

  props: {
    account_name: String,
    csrf_token: String,
    account_id: String,
    features_consumer_duty: Boolean,
    additional_options_member_firm_data_download: Boolean,
  },

  data() {
    return {
      accountName: this.account_name,
      csrfToken: this.csrf_token,
      accountId: this.account_id,
      featuresConsumerDuty: this.features_consumer_duty,
      statusClass: '',
      exportAccountOption: 1,
      exportAccountOptions: {
        all: 1,
        latest: 2,
      },
      exportAccountProcess: false,
    };
  },

  methods: {
    openModal() {
      $('#network-options-' + this.accountId).modal("show");
    },

    changeViewQuestionSection(key) {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken;
      axios.put(`/member-firm/options/change-view-question-section/${this.accountId}`, {'key': key, 'value': this.featuresConsumerDuty})
          .then((res) => {
            this.statusClass = 'success';
          })
          .catch((error) => {
            console.log('error', error)
            this.statusClass = 'danger';
            this.featuresConsumerDuty = this.features_consumer_duty
          })
    },
    exportAccount() {
      this.exportAccountProcess = true;
      axios.get(`/member-firm/options/export-account/${this.accountId}/${this.exportAccountOption}`, { responseType: 'blob' })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',  this.accountId + '_export_account.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.exportAccountProcess = false;
          })
          .catch((error) => {
            console.log('error', error);
            this.exportAccountProcess = false;
          });
    },
  },
};
</script>

<style scoped>
  .network-account-config-component .modal {}
  .network-account-config-component .modal-dialog {}
  .network-account-config-component .modal-content {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
    border: 1px solid #999;
    text-align: left;
  }
  .network-account-config-component .modal-content input, .modal-content select,
  .network-account-config-component .modal-content input, .modal-content label {
    height: auto;
    margin: auto;
    width: auto;
  }
.network-account-config-component .modal-header {}
.network-account-config-component .modal-body {}
</style>
